import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Features from "../components/Features";
import Showcase from "../components/Showcase";
import TechStack from "../components/TechStack";
import CTA from "../components/CTA";
import Footer from "../components/Footer";

const Landing = () => {
  return (
    <div className="min-h-screen bg-[#0b1626] text-white overflow-x-hidden">
      <Navbar />
      <main>
        <Hero />
        <Features />
        <Showcase />
        <TechStack />
        <CTA />
      </main>
      <Footer />
    </div>
  );
};

export default Landing;
